<template>
  <div>

    <!----------- LoRaWAN Network Device Details ------------>
    <b-row class="border-bottom mb-2">
      <b-col>
        <h3 class="mb-0">
          Network Details
        </h3>
        <small class="text-muted">
          Enter details that will enable the device to connect to the network
        </small>
      </b-col>
    </b-row>

    <!----------- Network Info  ------------>
    <b-row>

      <b-col>
        <b-form-group
          label="Network Type"
          label-for="networkType"
        >
          <b-form-input
            v-model="network.networkType.name"
            readonly
          />
        </b-form-group>

      </b-col>
      <b-col>
        <b-form-group
          label="Network Org Name"
          label-for="networkType"
        >
          <b-form-input
            v-model="network.networkOrgName"
            readonly
          />
        </b-form-group>

      </b-col>
    </b-row>

    <!-- Dev EUI -->
    <b-row>
      <b-col>
        <b-form-group
          label="Dev EUI"
          label-for="appEUI"
        >
          <validation-provider
            v-slot="{ errors }"
            name="Dev EUI"
            rules="required|regex:^[0-9a-fA-F]{16}$"
          >
            <b-form-input
              id="DevEUIInput"
              v-model="newDevice.network.devEUI"
              :state="errors.length === 0 && newDevice.network.devEUI.length > 0"
              placeholder="Unique ID of a device"
            />
            <small class="text-danger">{{ errors[0] ? "Please enter a 16-character hexadecimal string." : "" }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <!-- App EUI-->
      <b-col>
        <b-form-group
          label="App EUI"
          label-for="appEUI"
        >
          <validation-provider
            #default="{ errors }"
            name="App EUI"
            rules="required|regex:^[0-9a-fA-F]{16}$"
          >
            <b-form-input
              id="AppEUIInput"
              v-model="newDevice.network.appEUI"
              :state="errors.length === 0 && newDevice.network.appEUI.length > 0 "
              placeholder="Unique ID of the application of the device"
            />
            <small class="text-danger">{{ errors[0] ? "Please enter a 16-character hexadecimal string." : "" }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <!-- App Key-->
      <b-col>
        <b-form-group
          label="App Key"
          label-for="appKey"
        >
          <validation-provider
            #default="{ errors }"
            name="App Key"
            rules="required|regex:^[0-9a-fA-F]{32}$"
          >
            <b-form-input
              id="appKeyInput"
              v-model="newDevice.network.appKey"
              :state="errors.length === 0 && newDevice.network.appKey.length > 0 "
              placeholder="Secret key which is used via the Join mechanism"
            />
            <small class="text-danger">{{ errors[0] ? "Please enter a 32-character hexadecimal string." : "" }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
    </b-row>

    <!-- Device Profile -->
    <b-row v-if="network.networkType.identifier === 'prym-chirpstack'">
      <b-col>
        <b-form-group
          label="Device Profile"
          label-for="deviceProfile"
        >
          <validation-provider

            name="Device Profile"
            rules="required"
          >
            <b-form-input
              v-model="newDevice.network.deviceProfileId"
              placeholder="Device Profile ID for the Device"
            />
          </validation-provider>
        </b-form-group>
      </b-col>

      <!-- Application -->
      <b-col>
        <b-form-group
          label="Application"
          label-for="application"
        >
          <validation-provider

            name="Application"
            rules="required"
          >
            <b-form-input
              v-model="newDevice.network.applicationId"
              placeholder="Application ID for the Device"
            /></validation-provider>
        </b-form-group>
      </b-col>
    </b-row>

    <!----- Check if device exists in network, if it does, show error message ----->
    <b-row>
      <b-col>
        <b-form-group
          label="Check if device exists in network"
          label-for="checkDevice"
        >
          <b-button
            variant="primary"
            :disabled="checking && newDevice.network.devEUI === '' || newDevice.network.appEUI === '' || newDevice.network.appKey === ''"
            @click="checkDeviceExists"
          >
            <div v-if="!checking">
              Check
            </div>
            <b-spinner
              v-if="checking"
              small
              type="grow"
              variant="info"
            />
          </b-button>
          <!--add green checkmark if device exists in network-->
          <b-form-invalid-feedback
            id="input-live-feedback"
          >
            {{ checkingMessage }}
          </b-form-invalid-feedback>
        </b-form-group>

      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BSpinner,
  BButton,
  BFormInvalidFeedback,
} from 'bootstrap-vue'
import { API } from 'aws-amplify'
import { ValidationProvider } from 'vee-validate'
// import required and regex
import { required, regex } from '@validations'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    ValidationProvider,
    BSpinner,
    BButton,
    BFormInvalidFeedback,

  },
  props: {
    newDevice: {
      type: Object,
      required: true,
    },
    network: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      changeId: true,
      deviceExists: false,
      checking: false,
      checkingMessage: '',

      required,
      regex,
      apps: [],
      deviceProfiles: [],
    }
  },
  watch: {
    network: {
      handler() {
        if (this.network.networkType.identifier === 'tts') {
          this.listApplicationsTTS()
        }
      },

      deep: true,
    },
  },
  methods: {
    async listApplicationsTTS() {
      try {
        const apps = await API.get('NetworkAPI', '/applications', {
          queryStringParameters: {
            apiKey: this.network.api_key,
          },
        })
        apps.applications.forEach(app => {
          this.apps.push(app.ids.application_id)
        })
      } catch (error) {
        // console.log(error)
      }
    },

    async checkDeviceExists() {
      this.checking = true
      this.checkingMessage = 'Checking if device exists in network...'
      try {
        const response = await API.get('NetworkAPI', '/devices', {
          queryStringParameters: {
            network: this.network.networkType.identifier,
            apiKey: this.network.api_key,
            app_eui: this.newDevice.network.appEUI,
            app_key: this.newDevice.network.appKey,
            dev_eui: this.newDevice.network.devEUI,
          },
        })
        if (response.device.id) {
          this.checkingMessage = 'Device exists in network'
          this.deviceExists = true
        } else {
          this.checkingMessage = 'Device does not exist in network'
          this.deviceExists = false
        }
      } catch (error) {
        // console.log(error)
      }
    },
  },
}

</script>

<style>

</style>
